var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3 27.376s4.766-4.733 6.383-6.4c5.117-5 2.567-15.3 2.567-15.3S25 3.126 20 8.243c-3.9 3.8-6.434 6.433-6.434 6.433s-6.4-1.333-10.233 2.5L23.75 37.643c3.833-3.884 2.55-10.267 2.55-10.267zm-2.5-15a3.334 3.334 0 114.717 4.712 3.334 3.334 0 01-4.717-4.712zM5 35.976a13.017 13.017 0 008.333-3.333l-5-5C5 29.309 5 35.976 5 35.976z",
    fill: "#DFE2E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.961f375dab412b7e79b4f17ed6744860.svg";
export { ForwardRef as ReactComponent };